import React from 'react';
import { Route } from 'react-router-dom';
import Layout from '../components/Layout';
import RoleBasedRoute from '../components/RoleBasedRoute';
// Importar todos los componentes
import Home from '../Home';
import Users from '../pages/Users';
import EditUser from '../pages/EditUser';
import AddUser from '../pages/AddUser';
import RequestsPendingToPay from '../pages/RequestsPendingToPay';
import OverTime from '../pages/OverTime';
import AllRequests from '../pages/AllRequests';
import AnualRequests from '../pages/AnualRequests';
import GeneralPaymentReport from '../pages/GeneralPaymentReport';
import RequestsPendingApproval from '../pages/RequestsPendingApproval';
import OverTimeRequest from '../pages/OverTimeRequest';
import Report from '../pages/Report';
import ManageRequests from '../pages/ManageRequests';
import AddConcept from '../pages/AddConcept';
import EditConcept from '../pages/EditConcept';
import Concepts from '../pages/Concepts';
import SubConcepts from '../pages/SubConcepts';
import AddSubConcept from '../pages/AddSubConcept';
import EditSubConcept from '../pages/EditSubConcept';

// Mapeo de nombres de componentes a componentes reales
const componentMap = {
    'Home': Home,
    'Users': Users,
    'EditUser': EditUser,
    'AddUser': AddUser,
    'RequestsPendingToPay': RequestsPendingToPay,
    'OverTime': OverTime,
    'AllRequests': AllRequests,
    'AnualRequests': AnualRequests,
    'GeneralPaymentReport': GeneralPaymentReport,
    'RequestsPendingApproval': RequestsPendingApproval,
    'OverTimeRequest': OverTimeRequest,
    'Report': Report,
    'ManageRequests': ManageRequests,
    'AddConcept': AddConcept,
    'EditConcept': EditConcept,
    'Concepts': Concepts,
    'SubConcepts': SubConcepts,
    'AddSubConcept': AddSubConcept,
    'EditSubConcept': EditSubConcept,
};

// Función para generar rutas automáticamente
export const generateRoutes = (routesConfig) => {
    return routesConfig.map((routeConfig, index) => {
        const Component = componentMap[routeConfig.component];

        if (!Component) {
            console.warn(`Componente no encontrado: ${routeConfig.component}`);
            return null;
        }

        return (
            <Route
                key={`route-${index}`}
                path={routeConfig.path}
                element={
                    <RoleBasedRoute allowedRoles={routeConfig.roles}>
                        <Layout
                            routes={routeConfig.breadcrumbs}
                            {...(routeConfig.layoutProps || {})}
                        >
                            <Component />
                        </Layout>
                    </RoleBasedRoute>
                }
            />
        );
    }).filter(Boolean); // Filtrar elementos null
};